var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('v-card',{attrs:{"elevation":"6"}},[_c('avvocato-edit',{attrs:{"id":_vm.$route.params.id},on:{"close":_vm.close}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }